const URL = {
  LIST_LEARNING_CONTENT: 'LearningPackage/GetByList',
  GET_LEARNING_CONTENT: 'LearningPackage/GetById',
  CLONE_LEARNING_CONTENT: 'LearningPackage/Clone',
  PREVIEW_LEARNING_CONTENT: 'LearningPackage/Preview',
}

export default URL
